import { createApi } from '@reduxjs/toolkit/query/react';

import type { ApiParamsSchemaType } from '@/global/schemas/api.schema';
import type { GetNodeListSchemaType } from '@/global/schemas/node.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const nodeApi = createApi({
  reducerPath: REDUX_SLICE.NODE_API,
  tagTypes: ['Nodes'],
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    fetchNodes: builder.query<GetNodeListSchemaType, ApiParamsSchemaType>({
      query: ({ page = 1, size = 6, search, sort, filter }) => {
        const params: Record<string, any> = { page, size };

        if (search) params.search = search;
        if (sort) params.sort = sort;
        if (filter) params.filter = filter;

        return {
          path: `v1/nodes`,
          params,
        };
      },
      transformResponse: (returnValue: GetNodeListSchemaType) => returnValue,
      providesTags: (_result, _error) => [{ type: 'Nodes' }],
    }),
  }),
});

export const { useFetchNodesQuery } = nodeApi;
